/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-22 17:50:53
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-07 18:24:13
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/selectors.ts
 * @LastEditTime: 2021-03-24 16:32:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/slice/selectors.ts
 */

import { EnumReducers } from './index';
export { EnumReducers };
import { EnumReducers as parentEnumReducers } from 'src/store';
import {
  getSalesChannel as _getSalesChannel,
  getSalesChannelName as _getSalesChannelName,
  getGeneralFeaturedProduct as _getGeneralFeaturedProduct,
  getHasModified as _getHasModified,
  getCollapseValidationMsgDisplay as _getCollapseValidationMsgDisplay,
  getCollapseOpenStatus as _getCollapseOpenStatus,
  getState as _getState,
  getContent as _getContent,
  getOpeningCollapse as _getOpeningCollapse,
  getVisibleCollapse as _getVisibleCollapse,
  getCollapseStatus as _getCollapseStatus,
  getOrder as _getOrder,
  getSubmitStamp as _getSubmitStamp,
  getLoaded as _getLoaded,
  getOpeningCollapse2 as _getOpeningCollapse2,
  getH1TagUuid as _getH1TagUuid,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getEntityUuid as _getEntityUuid,
  getTranslationState as _getTranslationState,
} from 'src/tools/selectors/salesChannel';
const reducers = (reducer) => {
  return [parentEnumReducers.salesChannelContent, reducer];
};

const getReducer = (reducer) => {
  return reducers(reducer);
};

const getLoaded = (reducer) => {
  return _getLoaded(reducers(reducer));
};

const getSubmitStamp = (reducer) => {
  return _getSubmitStamp(reducers(reducer));
};

const getContent = (reducer, id) => {
  return _getContent(reducers(reducer), id);
};

const getOpeningCollapse = (reducer, order?) => {
  return _getOpeningCollapse(reducers(reducer), order);
};

const getVisibleCollapse = (reducer, order?) => {
  return _getVisibleCollapse(reducers(reducer), order);
};

const getCollapseStatus = (reducer, id) => {
  return _getCollapseStatus(reducers(reducer), id);
};

const getOrder = (reducer) => {
  return _getOrder(reducers(reducer));
};

export {
  getOrder,
  getCollapseStatus,
  getVisibleCollapse,
  getOpeningCollapse,
  getContent,
  getSubmitStamp,
  getLoaded,
  getReducer,
  reducers,
};

export const getCollapseValidationMsgDisplay = (reducer, id) => {
  return _getCollapseValidationMsgDisplay(reducers(reducer), id);
};

export const getCollapseOpenStatus = (reducer, id) => {
  return _getCollapseOpenStatus(reducers(reducer), id);
};

export const getState = (reducer) => {
  return _getState(reducers(reducer));
};

export const getHasModified = (reducer) => {
  return _getHasModified(reducers(reducer));
};

export const getSalesChannel = (reducer) => {
  return _getSalesChannel(reducers(reducer));
};

export const getSalesChannelName = (reducer) => {
  return _getSalesChannelName(reducers(reducer));
};

export const getGeneralFeaturedProduct = (reducer) => {
  return _getGeneralFeaturedProduct(reducers(reducer));
};

export const getOpeningCollapse2 = (reducer) => {
  return _getOpeningCollapse2(reducers(reducer));
};

export const getH1TagUuid = (reducer) => {
  return _getH1TagUuid(reducers(reducer));
};

export const getGeneralMiniProgramShare = (reducer) => {
  return _getGeneralMiniProgramShare(reducers(reducer));
};

export const getGeneralMiniProgramPageInfo = (reducer) => {
  return _getGeneralMiniProgramPageInfo(reducers(reducer));
};

export const getEntityUuid = (reducer) => {
  return _getEntityUuid(reducers(reducer));
};

export const getTranslationState = (reducer) => {
  return _getTranslationState(reducers(reducer));
};
